import DefaultMarker from 'assets/images/icon/markers/DefaultMarker.svg';
import HealthAndSafetyMarker from 'assets/images/icon/markers/HealthAndSafetyMarker.svg';
import SmartGatewayMarker from 'assets/images/icon/markers/SmartGatewayMarker.svg';
import SmartLockerMarker from 'assets/images/icon/markers/SmartLockerMarker.svg';
import VerkadaCameraMarker from 'assets/images/icon/markers/VerkadaCamerasMarker.svg';
import ZezamiiAccessMarker from 'assets/images/icon/markers/ZezamiiAccessMarker.svg';
import ZezamiiGatewayMarker from 'assets/images/icon/markers/ZezamiiGatewayMarker.svg';
import ZezamiiLockerMarker from 'assets/images/icon/markers/ZezamiiLockerMarker.svg';
import IrDoorsMarker from 'assets/images/icon/markers/IrDoorsMarker.svg';
import IrLiftsMarker from 'assets/images/icon/markers/IrLiftsMarker.svg';
import IrLiftFloorsMarker from 'assets/images/icon/markers/IrLiftFloorsMarker.svg';

// Category icons are stored as ZezamiiIcon registry names (strings) so this
// config stays serialisable — it gets hydrated into Redux via remoteConfig
// and Redux Toolkit's serializableCheck flags React components. Consumers
// render `<ZezamiiIcon name={cfg.icon} color={...} />` at the call site.

// Device custom-field titles the Access APP owns: field-first records of the BLE lock
// settings the app applied to the hardware. The dashboard shows them read-only (a web
// write would fabricate hardware state), and the backend rejects a POST of these without
// source:'device' (App Server constants/appOwnedFieldTitles.js — keep in lockstep).
export const APP_OWNED_FIELD_TITLES = ['Special Value', 'Two Factor Unlock', 'Remote Unlock Enabled'];

export const defaultCategory = {
	1: {
		name: 'Health & Safety',
		icon: 'alert',
		iconTone: 'warning',
		markerIcon: HealthAndSafetyMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	12: {
		name: 'Smart Locks',
		// Same iconography as Zezamii Access (17): to the user a TTLock door and a
		// Control door are the same product — a door under Access, not a padlock.
		icon: 'digital-lock',
		markerIcon: ZezamiiAccessMarker,
		showOnAdditionalFields: [
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Has Gateway',
			'Lock Online',
			'Electric Quantity',
			'Lock GroupID',
			'Lock Group Name'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Electric Quantity Update Date',
			'Feature Value',
			'Has Gateway',
			'Wireless Keypad Feature Value',
			'Floor Number',
			'Building Number',
			'Lock Name',
			'Special Value',
			'Sector',
			'No Key Pwd',
			'Passage Mode',
			'Date',
			'Timezone Raw Offset',
			'Electric Quantity',
			'Bind Date',
			'Keyboard Pwd Version',
			'Lock Version Show Admin Kbpwd Flag',
			'Lock Version Group ID',
			'Lock Version Protocol Version',
			'Lock Version Protocol Type',
			'Lock Version Org ID',
			'Lock Version Logo URL',
			'Lock Version Scene'
		],
		editableCustomFields: []
	},
	13: {
		name: 'Smart Gateway',
		icon: 'gateway',
		markerIcon: SmartGatewayMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: ['Lock Data'],
		editableCustomFields: []
	},
	14: {
		name: 'Smart Locker',
		icon: 'locker-unit',
		markerIcon: SmartLockerMarker,
		showOnAdditionalFields: [
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Has Gateway',
			'Electric Quantity',
			'Lock GroupID',
			'Lock Group Name'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Electric Quantity Update Date',
			'Feature Value',
			'Has Gateway',
			'Wireless Keypad Feature Value',
			'Floor Number',
			'Building Number',
			'Lock Name',
			'Special Value',
			'Sector',
			'No Key Pwd',
			'Passage Mode',
			'Date',
			'Timezone Raw Offset',
			'Electric Quantity',
			'Bind Date',
			'Keyboard Pwd Version',
			'Lock Version Show Admin Kbpwd Flag',
			'Lock Version Group ID',
			'Lock Version Protocol Version',
			'Lock Version Protocol Type',
			'Lock Version Org ID',
			'Lock Version Logo URL',
			'Lock Version Scene'
		],
		editableCustomFields: ['Size', 'Feature']
	},
	15: {
		name: 'Verkada Cameras',
		icon: 'dome-camera',
		markerIcon: VerkadaCameraMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: ['Lock Data'],
		editableCustomFields: []
	},
	23: {
		name: 'VORTEX Cameras',
		icon: 'dome-camera',
		markerIcon: VerkadaCameraMarker,
		showOnAdditionalFields: ['Status', 'Model', 'MAC', 'Firmware', 'Device Type'],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	17: {
		name: 'Zezamii Access',
		icon: 'digital-lock',
		markerIcon: ZezamiiAccessMarker,
		showOnAdditionalFields: [
			'Status',
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		],
		editableCustomFields: []
	},
	18: {
		name: 'Zezamii Gateway',
		icon: 'gateway',
		markerIcon: ZezamiiGatewayMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: ['Lock Data'],
		editableCustomFields: []
	},
	19: {
		name: 'Zezamii Locker',
		icon: 'locker-unit',
		markerIcon: ZezamiiLockerMarker,
		editableCustomFields: ['Size', 'Feature'],
		showOnAdditionalFields: [
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Size',
			'Feature',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		]
	},
	20: {
		name: 'IR Doors',
		icon: 'door',
		markerIcon: IrDoorsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	21: {
		name: 'IR Lifts',
		icon: 'lift',
		markerIcon: IrLiftsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	22: {
		name: 'IR Lift Floors',
		icon: 'floor',
		markerIcon: IrLiftFloorsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	// Inception (integration 9) — doors/areas/lift-floors synced from the
	// controller. Markers reuse the IR set (same iconography) until dedicated
	// Inception assets land.
	24: {
		name: 'Inception Doors',
		icon: 'door',
		markerIcon: IrDoorsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	25: {
		name: 'Inception Areas',
		icon: 'asset',
		// Neutral pin — an area is NOT actionable (a door-shaped marker invites
		// an unlock attempt on something that can't unlock).
		markerIcon: DefaultMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	26: {
		name: 'Inception Lift Floors',
		icon: 'floor',
		markerIcon: IrLiftFloorsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	}
};

/**
 * Returns the ZezamiiIcon name for a given defaultCategoryID.
 * Falls back to 'asset' when the category is unknown.
 */
export const getDeviceIconName = (defaultCategoryID) => defaultCategory[defaultCategoryID]?.icon || 'asset';

/**
 * Returns the human-readable category name for a given defaultCategoryID
 * (e.g. 'Inception Doors', 'IR Lifts', 'Smart Locks'). Used to group/label
 * devices by category in pickers. Falls back to 'Other' when unknown.
 */
export const getDeviceCategoryName = (defaultCategoryID) => defaultCategory[defaultCategoryID]?.name || 'Other';
